'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getPosition(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/positions`
        const result = await axios.get(url, {
          ...costumHeader('Get Position Allowance', 4),
          params
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getPositionAllowance(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/positionallowances`
        const result = await axios.get(url, {
          ...costumHeader('Get Position Allowance', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  savePositionAllowance(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/positionallowances`
        const result = await axios.post(url, body, costumHeader('Save Position Allowance', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editPositionAllowance(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/positionallowances/${body.id}`
        const result = await axios.put(url, body, costumHeader('Edit Position Allowance', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deletePositionAllowance(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/positionallowances/${body.id}`
        const result = await axios.delete(url, body, costumHeader('Delete Position Allowance', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  }
}

export default { actions }